export default __webpack_public_path__ + "static/media/cif-ng.566b9bff.svg";